import apiClient from '@/lib/api/apiClient'
import { extractErrorMessage } from '@/lib/utils/errorHandling'
import type {
  Policy,
  PolicyListParams,
  PolicyListResponse,
  PolicySubmitPayload,
} from '../types'

export async function getPolicies(
  params: PolicyListParams = {},
): Promise<PolicyListResponse> {
  try {
    const response = await apiClient.get<PolicyListResponse>('/api/policy', { params })
    return response.data
  } catch (error) {
    throw new Error(extractErrorMessage(error) || 'Failed to load policies')
  }
}

export async function savePolicy(
  payload: PolicySubmitPayload,
  policyKey?: string,
): Promise<Policy> {
  try {
    // Legacy: create uses singular `/api/policy`, update uses plural `/api/policies/:policy_key`.
    const url = policyKey
      ? `/api/policies/${encodeURIComponent(policyKey)}`
      : '/api/policy'
    const response = await apiClient.post<Policy>(url, payload)
    return response.data
  } catch (error) {
    throw new Error(extractErrorMessage(error) || 'Failed to save policy')
  }
}
